import { Chip } from '@mui/material';
import { FilterType, FilterValue } from './FilterableTable';
import { formatDate } from '../../utils/string.helpers';
import './FilterableTable.scss';

// eslint-disable-next-line
type FilterChangedFunc = (newValue: FilterValue) => void;
interface FilterInfoProps {
  type: FilterType;
  filterValue?: FilterValue;
  onFilterChanged: FilterChangedFunc;
}

export default function FilterInfo({ type, filterValue, onFilterChanged }: FilterInfoProps) {
  const getChipText = () => {
    if (!filterValue) return undefined;
    switch (type) {
      case 'string':
      case 'number':
        return filterValue?.value;
      case 'boolean':
        return filterValue?.value ? 'Yes' : '';
      case 'date':
        return formatDate(filterValue.value);
      case 'values':
        if (Array.isArray(filterValue.value) && filterValue.value.length > 1)
          return `${filterValue.value.length} selected`;
        return filterValue.value[0];
    }
  };
  const emptyValue = { ...filterValue, operator: undefined, value: type === 'values' ? [] : undefined };
  if (type === 'values' && !filterValue?.value?.length) return <></>;
  if (filterValue?.value === undefined) return <></>;
  return (
    <Chip
      label={
        <div>
          {filterValue?.operator && <span className="chip-operation">{filterValue.operator ?? '='}</span>}
          <span className="chip-value">{getChipText()}</span>
        </div>
      }
      clickable
      onDelete={() => {
        onFilterChanged(emptyValue);
      }}
      size="small"
      color="info"
      variant="outlined"
      className="filter-chip"
    />
  );
}
